import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";

const DonutChartLine = ({ data, heights }) => {
  // Data for the chart

  // Custom label renderer for external labels with subtle curved lines
  const renderCustomizedLabel = (props) => {
    const { cx, cy, midAngle, outerRadius, name, value, percent } = props;
    const RADIAN = Math.PI / 180;
    // const radius = outerRadius + 10;

    const startX = cx + outerRadius * Math.cos(-midAngle * RADIAN);
    const startY = cy + outerRadius * Math.sin(-midAngle * RADIAN);

    const midRadius = outerRadius + 25;
    const midX = cx + midRadius * Math.cos(-midAngle * RADIAN);
    const midY = cy + midRadius * Math.sin(-midAngle * RADIAN);

    const endX = midX > cx ? midX + 40 : midX - 40;
    const endY = midY;

    const textAnchor = midX > cx ? "start" : "end";
    const textX = endX + (midX > cx ? 10 : -10);

    const path = `
      M ${startX},${startY}
      L ${midX},${midY}
      L ${endX},${endY}
    `;

    return (
      <g>
        <path d={path} fill="none" stroke="#888" strokeWidth={1} />
        <text
          x={textX}
          y={endY}
          fill="#333"
          textAnchor={textAnchor}
          dominantBaseline="middle"
          fontSize={14}
        >
          {(() => {
            const absValue = Math.abs(value);
            let formattedValue = "";
            if (absValue >= 1000000) {
              formattedValue = `${(absValue / 1000000).toFixed(2)}M`;
            } else if (absValue >= 1000) {
              formattedValue = `${(absValue / 1000).toFixed(2)}K`;
            } else {
              formattedValue = absValue.toFixed(2);
            }

            return percent > 0
              ? `$${formattedValue} (${percent}%)`
              : `-$${formattedValue} (${percent}%)`;
          })()}
        </text>
      </g>
    );
  };

  return (
    <div style={{ width: "100%", height: heights, marginTop: "-20px" }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={90} // Increased size
            outerRadius={120} // Increased size
            paddingAngle={2}
            dataKey="value"
            labelLine={false}
            label={renderCustomizedLabel}
            cursor={"pointer"}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip
            formatter={(value) =>
              `$${value.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`
            }
          />
          <Legend
            formatter={(value) => (
              <span style={{ color: "#555", fontSize: "14px" }}>{value}</span>
            )}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default DonutChartLine;
